export const MeetingContext = {
    PROCEDURE: 'procedures',
    CANDIDATE: 'candidates',
    RELATIONCONTACT: 'relationcontacts',
};

export const ConfigurationMode = {
    LOGIN: 'login',
    TOTP: 'totp',
    SIGNED: 'signed',
}